import styled from '@emotion/styled';
const Hr = styled('hr')({
    opacity: 0.15,
    height: 0,
    border: 'none',
    borderBottom: '1px solid currentColor;',
});
export default Hr;
//# sourceMappingURL=Hr.js.map